module.exports = __webpack_public_path__ + "e34f1e4acd89e80fac15aa97c03b07e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/img/brush-icon.png
// module id = 20
// module chunks = 0